'use strict';

import { appState, authState } from './appState.js';
import { lmAppStorage } from './lmAppStorage.js';
import { urlSafe } from './urlTools.js';
import { nextFrame } from './asyncTools.js';
import { VarMgr } from './VarMgr.js';
import { notifyShutdown } from './ShutdownNotify.js';
import { mPost } from './ajaxWrapNew.js';
import { checkCryptAfterLockRelease } from './crypter.js';


function snapSetData(key, value) {
    //sessionStorage.setItem(`snap:${key}`, value);
    if (value === null || value === undefined) {
        document.documentElement.removeAttribute('data-' + key);
    } else {
        document.documentElement.setAttribute('data-' + key, value);
    }
}

function snapGetData(key) {
    //return sessionStorage.getItem(`snap:${key}`);
    return document.documentElement.getAttribute('data-' + key);
}

var runShowOnce = false;

var appVarMgrLoad = () => {
    const appVarmgr = document.getElementById('app-varmgr');
    if (appVarmgr) {
        const data = JSON.parse(appVarmgr.textContent);
        if (data && typeof data === 'object') {
            VarMgr.setAll(data);
        }
        appVarmgr.remove();
    }
    appVarMgrLoad = () => {};
};


function clearLockIfOwner() {
    const LOCK_KEY = 'conversion_lock';


    function readLock() {
        const raw = localStorage.getItem(LOCK_KEY);
        if (!raw) return null;
        try { return JSON.parse(raw); } catch { return null; }
    }
    function canUnlock(lock) {
        if (!lock) return false;
        if (!lock.expiresAt || lock.expiresAt < Date.now()) return false;
        if (lock.ownerId !== appState.getTabId() && lock.ownerId !== appState.getPrevTabId()) return false;
        return true;
    }
    function release() {
        const globalCryptConf = appState.getGlobalCryptConf();
        if (typeof globalCryptConf !== 'undefined') { globalCryptConf.lock = null; }
        snapSetData('bf-locked', null);
        localStorage.removeItem(LOCK_KEY);
        $(window).trigger('lock-released');
        try {
            const bc = 'BroadcastChannel' in window ? new BroadcastChannel('conversion_lock_channel') : { postMessage(){} , onmessage:null };
            bc.postMessage({ type: 'released', payload: null });
        } catch {}
    }

    let lock = readLock();
    if (!lock) {
        const globalCryptConf = appState.getGlobalCryptConf();
        if (typeof globalCryptConf === 'undefined' || !globalCryptConf?.lock) return false;
    } else if (!canUnlock(lock)) {
        snapSetData('bf-locked', '1');
        return false;
    }

    appState.unlocking = true;

    // faster releaselock if owner;
    mPost('releaseLock', {
        tabId: appState.getTabId(),
        ptabId: appState.getPrevTabId() || '',
        lockKeySkip: 1
    }, false).then(async (lockData) => {
        if (lockData.lock.released) {
            release();
        }
        if (lockData.checkCrypt) {
            checkCryptAfterLockRelease(lockData.checkCrypt);
        }

        appState.unlocking = false;
    }).catch((err) => {
        console.error('Unlock error:', err);
        release();

        appState.unlocking = false;
    });

    return true;
}

function pageShowHandler(evt) {
    //console.log('pageShow handled', runShowOnce);
    if (runShowOnce) return;
    runShowOnce = true;

    appVarMgrLoad();

    try {
        /* const loadBack = VarMgr.get('loadBack');
        if (loadBack) {
            if (lmAppStorage.loadBack(loadBack)) {
                // ja ir noticis veiksmīgs atgriešanās URL ielāde, tad pārtraucam turpmāko lapas inicializāciju
                return;
            }
        } */
        const saveBack = VarMgr.get('saveBack');
        if (saveBack) {
            lmAppStorage.saveBack(saveBack.key, saveBack.url);
            //document.dispatchEvent(new CustomEvent('app-storage:saveback', { detail: { key: saveBack.key, url: saveBack.url } }));
        }
    } catch (error) {
        console.error('Error handling loadBack/saveBack:', error);
    }

    if (appState.reloading) {
        //console.log('* appState.reloading is true; add is-navigating-away');
        document.body.classList.add('is-navigating-away');
        return;
    }

    // Atrodam visus Select2 laukus lapā un liekam tiem sinhronizēties
    $('.select2-hidden-accessible').each(function() {
        var $this = $(this);
        // Ja laukam ir kāda vērtība, pasakām Select2 to uzzīmēt
        if ($this.val()) {
            $this.trigger('change.select2');
        }
    });

    const e = evt || { persisted: false };
    appState.persisted(e.persisted);

    // When the page comes from BFCache, 'persisted' will be true (in all major browsers)
    // @ts-ignore
    const navType = performance.getEntriesByType('navigation')[0]?.type;

    clearLockIfOwner();

    // If it comes from BFCache or back_forward, compare it to the original state
    // If there is a mismatch, reload the page (safeReload)
    // If it comes from a normal load, save the authorization state
    // If it comes from BFCache and everything matches, unhide the page

    var testMismatch = false;
    var snapLogged, snapHash;

    // e.persisted ir TRUE tikai tad, ja lapa atjaunota no BFCache atmiņas
    if (e.persisted) {
        // Nolasām, vai šim atdzīvinātajam stāvoklim bija mūsu zīmogs
        if (window.history.state && window.history.state.forceReload) {
            // Droši nokopējam pilnīgi visu esošo stāvokli jaunā objektā un nodzēšam tikai mūsu zīmogu, lai tas vairs neietekmētu nākamo salīdzināšanu
            const newState = { ...window.history.state };
            delete newState.forceReload;
            window.history.replaceState(newState, '');
            window.location.reload();
            return;
        }

        if ($('.showOnLoad').length) {
            $('.removeOvl').removeClass('removeOvl');
            $('.showOnLoad').animate({ opacity: 1 }, 300).promise().then(() => {
                /* $('.withOvl').addClass('removeOvl'); */
            });
        }
    }
    // parādam lapu atpakaļ!
    document.body.classList.remove('is-navigating-away');
    //console.log('remove is-navigating-away');

    try {
        if (e.persisted) {
            if (snapGetData('nobf') === '1') {
                urlSafe.reload();
                return;
            }
            // comes from BFCache
            snapLogged = snapGetData('snap-logged');
            snapHash = snapGetData('snap-hash') ?? '';
            testMismatch = true;
        } else if (navType === 'back_forward') {
            // Back/forward WITHOUT BFCache — "cold" loading, let's compare it with the initial state
            const snap = authState.getColdState();
            snapLogged = snap.loggedIn ? '1' : '0';
            snapHash = snap.pinHash || '';
            testMismatch = true;
        }

        if (testMismatch) {
            const curr = authState.getAuthState();

            const mismatch =
                (snapLogged !== (curr.loggedIn ? '1' : '0')) ||
                (snapHash !== (curr.pinHash || ''));

            if (mismatch) {
                // Leave hidden and reload fresh page, because login or pin status has changed
                urlSafe.reload();
                return;
            }
            // MACH: BFCache return, everything matches, show page
        }
    } catch (err) {
        console.error(err);

        if (testMismatch) {
            urlSafe.reload();
        }
    }

    if (!testMismatch) {
        // If it comes from a normal load, save the authorization state from globalCryptConf provided by the server
        authState.setAuthState(authState.getColdState());
    }

    // Normal load (not BFCache) — unhide if there was a mark
    // or BFCache return, but everything matches
    snapSetData('bf-hide', null);

    // (optional) clear snapshot
    snapSetData('snap-logged', null);
    snapSetData('snap-hash', null);
}

// Ja pārlūks atbalsta šo API (visi modernie iOS un Android atbalsta)
if (window.visualViewport) {
    const updateViewportHeight = () => {
        // Salīdzinām loga augstumu ar reālo redzamo augstumu.
        // Ja starpība ir lielāka par ~100px, tas gandrīz 100% nozīmē, ka ir atvērta klaviatūra.
        const isKeyboardOpen = (window.innerHeight - window.visualViewport.height) > 100;
        if (isKeyboardOpen) {
            // 1. SCENĀRIJS: Klaviatūra ir atvērta.
            // Uzticamies TIKAI visualViewport, lai čats precīzi uzsēstos uz klaviatūras.
            document.documentElement.style.setProperty('--real-vh', `${window.visualViewport.height}px`);
        } else {
            // 2. SCENĀRIJS: Klaviatūra ir ciet (vienkārši skrollē lapu, un adrešu josla mainās).
            // Mēs izdzēšam JS uzlikto inline stilu!
            // Tas ļauj pārlūkam atgriezties pie tava :root { --real-vh: 100dvh; } definējuma.
            document.documentElement.style.removeProperty('--real-vh');
        }
        // Iestatām CSS mainīgo ar PREZĪCU redzamo pikseļu skaitu
        /* document.documentElement.style.setProperty(
            '--real-vh',
            `${window.visualViewport.height}px`
        ); */
    };

    // Klausāmies gan uz resize, gan klaviatūras atvēršanos/skrollu
    window.visualViewport.addEventListener('resize', updateViewportHeight);
    window.visualViewport.addEventListener('scroll', updateViewportHeight);

    // Izsaucam uzreiz pie ielādes
    updateViewportHeight();
}

addEventListener('DOMContentLoaded', function() {
    //console.log('DOMContentLoaded handled');

    try {
        /* const loadBack = VarMgr.get('loadBack');
        if (loadBack) {
            // ja ir nodefinēts loadBack tad paslēpjam lapu, lai lietotājs neredzētu pāreju
            document.body.classList.add('is-navigating-away');
        } */

        appVarMgrLoad();

    } catch (error) {
        console.error('Error handling loadBack/saveBack:', error);
    }

    // Notify shutdown if necessary
    const shutdownNotifyElement = document.getElementById('shutdown-notify');
    if (shutdownNotifyElement) {
        notifyShutdown(shutdownNotifyElement.innerHTML);
    }
});

// When the page is “suspended” to BFCache, we immediately hide it and mark the state
addEventListener('pagehide', function (e) {
    runShowOnce = false;
    // Save login state and pinHash for comparison upon return
    const state = authState.getAuthState();
    snapSetData('snap-logged', state.loggedIn ? '1' : '0');
    snapSetData('snap-hash', state.pinHash || '');

    if (e.persisted) {
        // Current document's DOM along with data-* will be saved to BFCache → hiding until check
        snapSetData('bf-hide', '1');
    } else {
        snapSetData('bf-hide', null);
    }

    const historyState = window.history.state;
    if (historyState && historyState.forceReload) {
        document.body.classList.add('is-navigating-away');
        //console.log('historyState && historyState.forceReload; add is-navigating-away');
    }

    if ($('.showOnLoad').length) {
        //console.log('set opacity to 0 for .showOnLoad');
        $('.showOnLoad').css({ opacity: 0 });
        $('.removeOvl').removeClass('removeOvl');
    }
    // Reset the reloading state after handling pagehide
    appState.reloading = false;
}, false);

// Register listener and check immediately (if pageshow already fired)
addEventListener('pageshow', pageShowHandler, false);

// “Safety Net”: If the script loads after pageshow, check now
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // setTimeout, to allow the browser to immediately restore layout/DOM state after BFCache

    nextFrame().then(() => {
        setTimeout(() => {
            //console.log('Immediate pageshow handler', runShowOnce);
            pageShowHandler();
        }, 0);
    });
}